/* // 停车数据面板链接转发 */

import {request, serviceUrl} from "@/utils/request";

var requestMapping='/iot/box/business/parking/';

// 停车场总览
export function getParkingPandect() {
  return request({
    url: serviceUrl.iotboxService + requestMapping+'stall-status/overview',
  });
}

// 停车场进场历史记录
export function getParkingEnterRecord(size) {
  return request({
    url: serviceUrl.iotboxService + requestMapping+'enter/record',
    params: {size}
  });
}

// 停车场出场历史记录
export function getParkingLeaveRecord(size) {
  return request({
    url: serviceUrl.iotboxService + requestMapping+'leave/record',
    params: {size}
  });
}

// 临停缴费
export function getTemporaryPay() {
  return request({
    url: serviceUrl.iotboxService + requestMapping+'temporaryPay/list'
  });
}
